export const armorEnchantments = [
    {
    name: "+1",
    rarity: "common",
    bonus: "Gain a +1 enhancement bonus to armor bonus",
    },
    {
        rarity: "unique",
        name: "Beholder's Bane",
        bonus: "This armor has its caster level increased by 4 (plus this enchantment itself) for the purposes of being dispelled, additionally for rounds per day equal to your highest enchantment modifier this armor functions inside of an antimagic field (minimum 1).",        
    },
    {
        name: "Wild",
        rarity: "rare",
        bonus: "While polymorphed this armor continues to provide its bonus to your armor class, however you also still suffer all of its penalties such as max dex bonus or reduced speed.",
    },
    {
    name: "Swagmail",
    rarity: "legendary",
    bonus: "While wearing this armor you can wear an extra piece of clothing. They must be two different pieces of clothing, but otherwise all effects stack.",
    },  
    {
    name: "Sturdy",
    rarity: "common",
    bonus: "Gain a +4 enhancement bonus to CMD.",
    },
    {
    name: "Unhindering",
    rarity: "common",
    bonus: "Reduce the armor check penalty of the armor by 4, or by 2x the armor's highest enhancement bonus.",
    },
    {
    name: "Mobile",
    rarity: "common",
    bonus: "Increase the max dex of the armor by 2, or by the armor's highest enhancement bonus.",
    },
    {
    name: "Ogre's Strength",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to strength",
    },
    {
    name: "Decent Dexterity",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to dexterity",
    },
    {
    name: "Stout Constitution",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to constitution",
    },
    {
    name: "Tempting Charisma",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to charisma",
    },
    {
    name: "Guided Wisdom",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to wisdom",
    },
    {
        name: "Mental Focus",
        rarity: "rare",
        bonus: "Grants the wearer a +2 enhancement bonus on concentration checks, or an amount equal to the armor's highest enhancement bonus.",
    },
    {
    name: "Substantial Intelligence",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to intelligence",
    },
    {
    name: "Air Conditioned",
    rarity: "common",
    bonus: "Gain fire resistance 10",
    },
    {
    name:"Handy Pouch",
    rarity: "rare",
    bonus: "As a free action you can store up to two items at a time on your person, such as gear, potions, or ammunition. Retrieving items stored this way is a swift action, unless its ammunition in which case it is a free action.",
    },
    {
    name:"Magic Wrist Sheath",
    rarity: "rare",
    bonus: "You can store a single weapon inside this magical sheath as a movement action, then as an immediate action cause it to spring into your hand.",
    },
    {
    name: "Foot Warmers",
    rarity: "common",
    bonus: "Gain cold resistance 10",
    },
    {
    name: "Insulated",
    rarity: "common",
    bonus: "Gain electricity resistance 10",
    },
    {
    name: "Deflecting",
    rarity: "common",
    bonus: "Gain a +2 deflection bonus to armor class",
    },
    {
    name: "Unbreakable",
    rarity: "common",
    bonus: "Increase your armors hardness by 10",
    },
    {
    name: "Indestructable",
    rarity: "common",
    bonus: "your armor gains 20 hit points",
    },
    {
    name: "Scabbing",
    rarity: "common",
    bonus: "+2 ehancement bonus to natural armor",
    },
    {
    name: "Storage",
    rarity: "common",
    bonus: "This armor has a magic wrist compartment that allows you to store a single small item as a standard action that could fit in one hand in a magical wrist area, and then retrieve it later as a swift action",
    },
    {
    name: "Spell storing",
    rarity: "rare",
    bonus: "You can store three levels of spells with the range of touch in this armor that you can then release as an immediate action. Anytime a creature hits the wearer with a melee or melee touch attack you can cast the spell in the armor on them as an immediate action if you desire. Alternatively you can cast the spell on yourself as an immediate action at any time. Each time you gain this enchantment increase the maximum levels of spells you can store by three, allowing you to store 3 level one spells, or 1 level three spell, and so on.",
    },
    {
    name: "Withstanding",
    rarity: "rare",
    bonus: "Gain a +4 resistance bonus to fortitude saves",
    },
    {
    name: "Quickening",
    rarity: "rare",
    bonus: "Gain a +4 resistance bonus to reflex saves",
    },
    {
    name: "Mind Defending",
    rarity: "rare",
    bonus: "Gain a +4 resistance bonus to will saves",
    },
    {
    name: "Invulnerable",
    rarity: "epic",
    bonus: "Gain +3 DR/-",
    },        
    {
    name:"Lesser Regenerative",
    rarity: "rare",
    bonus: "You gain fast healing 1. This fast healing does not stabalize a dying character, or stop bleed damage",
    },
    {
    name:"Rhino Hide",
    rarity: "rare",
    bonus: "Your charge attacks gain an additional +1 to attack, and deal an 2d6 + armor enhancement bonus damage.",
    },
    {
    name: "+2",
    rarity: "rare",
    bonus: "Gain a +2 enhancement bonus to armor bonus",
    },
    {
    name: "Dueling Armor",
    rarity: "epic",
    bonus: "Once per the armors enhancement bonus per day when the wearer is the target of a melee attack can as an immediate action make an opposed attack roll against it with a one handed weapon, gaining the armors enhancement bonus to this roll, if it is higher than the attack roll made against the wearer the armor deflects the blow and the wearer takes no damage from it. Touch effects will still trigger.",
    },
    {
    name: "Stabalizing Arms",
    rarity: "rare",
    bonus: "If an attack kills or knocks the wearer unconcious the wearer can choose to release stabalizing arms that keep the wearer from falling prone. It can retract these arms as a free action.",
    },
    {
    name: "Possessed",
    rarity: "legendary",
    bonus: "While the wearer is unconcious, dead, or mentally stopped from moving, but not physically stopped from moving, the armor comes alive and allows the wearer to make a single movement action on their turn with a speed of 30 feet, it can also use this to make 5 foot steps, if required the armor can make a climb, acrobatics, or swim check with a bonus equal to twice the armors enhancement bonus. If the wearer is attacked in this state they are considered flat-footed, and can take no other action that requires movement of their body.",
    },
    {
    name: "Emergency Teleporting",
    rarity: "epic",
    bonus: "If an attack kills or knocks the wearer unconcious the wearer can choose to teleport up to 10 feet plus 5 feet per armor enhancement bonus directly.",
    },
    {
    name: "Revenge Armor",
    rarity: "legendary",
    bonus: "If a melee attack kills or knocks the wearer unconcious the creature that knocked them out or killed them takes 1d10 damage per enhancement bonus of the armor (minimum 1d10), and becomes shakened for 1d4 rounds. Afterwards any attack by the wearer against a creature that knocked them out or killed them gains the armors enhancement bonus as a morale bonus to attack and damage against it.",
    },
    {
    name: "Hastening",
    rarity: "rare",
    bonus: "Increase your land speed by 10 feet",
    },
    {
    name:"Dodging",
    rarity: "common",
    bonus: "You gain a +1 dodge bonus to armor class.",
},
    {
    name: "Shielding",
    rarity: "rare",
    bonus: "Gain a +4 shield bonus to armor class. This bonus does not stack with a shield",
    },
    {
    name: "Arachnid Harness",
    rarity: "common",
    bonus: "This armor can sprout legs from the ribs, and gain a +8 circumstance bonus to climb checks and allow the wearer to attempt climb checks at full speed without needing their hands or feet, or to lose dexterity bonus to ac while climbing.",
    },
    {
    name: "Vanishing",
    rarity: "epic",
    bonus: "Once per day per enhancement bonus of this armor (minimum 1) as a movement action you can cause yourself to become invisible as per the invisibility spell for 2 rounds.",
    },        
    {
    name: "Aquaplate",
    rarity: "common",
    bonus: "You can move at full speed inside of water, and gain a +8 circumstance bonus to swim checks. You gain fast healing 1 while fully submerged in water.",
    },
    {
    name: "Slick Armor",
    rarity: "epic",
    bonus: "You gain a +4 bonus to your CMD against grapples, a +5 to escape artist checks, and using escape artist to escape a grapple becomes a movement action for you.",
    },
    {
    name: "Resistance",
    rarity: "epic",
    bonus: "+2 resistance to all saves",
    },
    {
    name: "Armor of Insults",
    rarity: "epic",
    bonus: "This armor has a large sneering face on the front. Once per day you can cause the mouth to unleash a torrent of verabl abuse at all hostile creatures within 60 feet who can see and hear the wearer, all creatures affected must make a will save dc 15 + armor enhancement bonus or be complused to attack the weared for 3 rounds. If attacking the wearer would put a creature at risk (even moving through threatened space) it can act normally. This is a language dependant, mind-affecting sonic effect, that has no effect on creatures with no spoken language.",
    },
    {
    name: "Mind buttressing Armor",
    rarity: "epic",
    bonus: "The wearer of this armor gains a +2 bonus to will saves against mind-effecting effects, and once per day when it fails a will saving throw against a mind-effecting effect it can choose to reroll as an immediate action.",
    },
    {
    name: "Swift Armor",
    rarity: "epic",
    bonus: "The wearer of this armor gains a +1 dodge bonus to armor class, and once per day as a movement action can cause themselves to become affected by haste for their armor enhancement bonus rounds.",
    },
    {
    name: "Champion",
    rarity: "rare",
    bonus: "The wearer of this armor gains a +2 sacred bonus to armor class and saves against the target of its smite, and can make an attack of opportunity against any creature that charges them and enters their threatened space.",
    },
    {
    name: "Potion Storing",
    rarity: "epic",
    bonus: "You can place a potion into this armor as a standard action, and then as an immediate action you can cause the potion to effect you.",
    },
    {
    name: "Giants Strength",
    rarity: "epic",
    bonus: "Gain a +4 enhancement bonus to strength",
    },
    {
    name: "Incredible dexterity",
    rarity: "epic",
    bonus: "Gain a +4 enhancement bonus to dexterity",
    },
    {
    name: "Mighty Constitution",
    rarity: "epic",
    bonus: "Gain a +4 enhancement bonus to constitution",
    },
    {
    name: "Alluring Charisma",
    rarity: "epic",
    bonus: "Gain a +4 enhancement bonus to charisma",
    },
    {
    name: "Inspired Wisdom",
    rarity: "epic",
    bonus: "Gain a +4 enhancement bonus to wisdom",
    },
    {
    name: "Vast Intelligence",
    rarity: "epic",
    bonus: "Gain a +4 enhancement bonus to intelligence",
    },
    {
    name:"Determination",
    rarity: "epic",
    bonus: "Once per combat, when the owner reaches 0 or fewer hit points, the item automatically provides a breath of life spell at caster level 10",
    },
    {
    name:"Lesser Fortification",
    rarity: "epic",
    bonus: "You gain a 25% chance to negate sneak attacks and critical hits",
    },
    {
    name:"Ethereal",
    rarity: "epic",
    bonus: "Once per floor as a swift action you can cause yourself to become ethereal for 1 round per 2 levels, an ethereal cruture is invisible, insubstantial, and capable of moving any direction even up or down though at half speed, you can move through solid objects including living creatures. while ethereal you cant see any further than 60 feet, force effects and abjuration effects still effect you normally, you are unable to affect any creature in the material plane while you are ethereal. if your ethereal effect ends while youre inside a material object you are shunted to the nearest open space and take 1d6 points of daamge per 5 feet you traveled",
    },
    {
    name:"Nullifying",
    rarity: "epic",
    bonus: "Once per floor when affected by a spell or spell-like ability you can choose to ignore it for the spells level worth of spell points (or half creatures HD if spell-like has no level)",
    },
    {
    name:"Mithral",
    rarity: "epic",
    bonus: "Reduce the armors weight class by 1 step, decrease its armor check penalty by 4, and increase its max dex bonus by 3.",
    },
    {
    name:"+3",
    rarity: "epic",
    bonus: "Gain a +3 enhancement bonus to armor bonus",
    },        
    {
        name:"Celestial",
        rarity: "legendary",
        bonus: "Once per day as a standard action you can cast fly that lasts for 1 round per level",
    },
    {
        name:"+4",
        rarity: "legendary",
        bonus: "Gain a +4 enhancement bonus to armor class.",
    },        
    {
        name:"Fortified",
        rarity: "legendary",
        bonus: "50% chance to negate sneak attacks and critical hits",
    },
    {
        name:"Untouchable",
        rarity: "legendary",
        bonus: "+5 DR/-",
    },
    {
        name:"Regenerative",
        rarity: "legendary",
        bonus: "You gain fast healing 3",
    },        
    {
        name:"Pain Fuel",
        rarity: "legendary",
        bonus: "Every time you take damage from an enemy gain 1 spell point.",
    },
    {
        name:"Fortitude Ward",
        rarity: "legendary",
        bonus: "Gain your armor's enhancement bonus as a resistance bonus to your fortitude save",
    },
    {
        name:"Will Ward",
        rarity: "legendary",
        bonus: "Gain your armor's enhancement bonus as a resistance bonus to your Will save",
    },
    {
        name:"Reflex Ward",
        rarity: "legendary",
        bonus: "Gain your armor's enhancement bonus as a resistance bonus to your Reflex save",
    },
    {
        name:"Countering",
        rarity: "epic",
        bonus: "Any roll that you use as part of a counter, or counter like ability such as parry or reposte receives a +2 bonus, this includes any retalitory attacks or such",
    },
    {
        name:"Power Storing",
        rarity: "legendary",
        bonus: "You can store up to your level of spell points in this armor, when it is fully charged any ability you use has its spell point cost reduced by 1, but it cant reduce an abilities cost below 1. You can store spell points in the armor as a free action, and spend the spell points stored in this armor as normal.",
    },
    {
        name:"Flame Ward",
        rarity: "legendary",
        bonus: "You gain fire and cold resistance 15. Any creature that misses you with a non-reach melee weapon or melee natural attack takes 1d6 + the armor's enchantment bonus of fire damage.",
    },
    {
        name:"Indomitable",
        rarity: "epic",
        bonus: "You can add your armor's enhancement bonus as an ehancement bonus to your CMD",
    },
    {
        name:"Time Altering",
        rarity: "unique",
        bonus: "You can spend 8 spell points to gain an additional movement action this turn. You can only do this once per round per time altering enchantment you have",
    },
    {
        name:"Divine Ward",
        rarity: "unique",
        bonus: "You can add 1/2 armor's enhancement bonus (rounded down) is added as a resistance bonus to all of your saves. Whenever you succeed a save vs a spell, Sp, Su, or Ex ability you regain hit points equal to your roll to save against it. This ability can only activate once per individual creature's abilities.",
    },
    {
        name:"Freedom",
        rarity: "unique",
        bonus: "You are constantly under the effect of the freedom of movement spell, if dispelled it can be reactivated as a standard action. Once per floor you can automatically remove a single status on yourself that is affecting your ability to move, even status's that are reducing how many movement actions you can take in a turn, such as staggered, nauseated, stunned, or similar effects.",
    },
    {
        name:"Warlord's Armor",
        rarity: "unique",
        bonus: "You gain a bonus to any weapon you wields enhancement bonus equal to 1/2 the enhancement bonus of this armor (rounded down). This stacks with a weapons usual enhancement modifier. This does not help you overcome DR.",
    },
    {
        name:"Ragemail",
        rarity: "unique",
        bonus: "While raging your armor becomes more powerful, the enhancement bonus of this armor increases equal to the morale bonus you gain to constitution due to your rage, and increases the bonus you gain to strength due to raging by the armors enchantment bonus (before it was modified by this enchantment)",
    },
    {
        name:"Caster's Guardian",
        rarity: "unique",
        bonus: "Whenever you cast a spell or spend spell points on a magic perk double your armors current enhancement bonus to armor, and gain temporary health equal to the spell points spent. Both of these bonuses last 1 round. The increase to the enhancement bonus does not stack, but the temporary hit points do.",
    },
    {
        name:"Featherplate",
        rarity: "unique",
        bonus: "Your armor counts as being unarmored regardless of its original type, it has no armor check penalty, and its max dex bonus increases by 10. Increase your base movement speed by 20 feet, and you can walk over any surface and it will support you, no matter its strength, such as liquids or leaves, however you can't end your turn on such a surface. When using acrobatics to move through a threatened space you move at full speed, and you can ignore up to 15 feet of difficult terrain each round while moving.",
    },
    {
        name:"+5",
        rarity: "unique",
        bonus: "You gain a +5 enhancement bonus to your armor class",
    },        
    {
        name:"Enchanted Arm",
        rarity: "legendary",
        bonus: "You gain a new arm on your torso made of metal that is fully under your control. The arm does not give the you any extra attacks or actions per round, though the arm can wield a weapon and make attacks as part of your attack routine (using two-weapon fighting). The arm can manipulate or hold items as well as your original arms (for example, allowing the you to use one hand to wield a weapon, another hand to hold a shield, and the third hand to throw a ranged weapon)",
    },
    {
        name:"Adaptive Armor",
        rarity: "unique",
        bonus: "You can replace your dexterity modifier to armor class with another ability score of your choosing.",
    },
    {
        name:"Karmic Plate",
        rarity: "unique",
        bonus: "Whenever a nearby creature confirms a critical fumble and you're within reach of being a potential target you are automatically the target, but the creature that confirmed the fumble must roll an attack roll at the same modifier that it confirmed the fumble on to hit you. You also reduce whatever damage you take from critical fumbles by half. Every time you are the target of a critical fumble you gain your armors enhancement bonus as a bonus to d20 rolls for 1 round.",
    },
    {
        name:"Titanic",
        rarity: "unique",
        bonus: "This comically oversized armor is so big you count as 1 size larger, increasing your weapon size, CMD, CMB, reach, and reducing your AC and attack by 1. Gain the armors enhancement bonus to CMB and CMD. Reduce the max dexterity bonus of this armor by 2, and increase its armor check penalty by 4, the armor counts as heavy, and reduce your speed by 5 feet.",
    },
    {
        name:"Absorption Rune",
        rarity: "unique",
        bonus: "Whenever you successfully save from a spell or spell-like ability caused by an enemy you regain spell points equal to your armors enhancement bonus",
    },
    {
        name:"Stealth Suit",
        rarity: "unique",
        bonus: "As a swift action you can become completely undetectable for 1 round, even from effects like true sight. You can activate this ability armor enhancement bonus/2 rounds per combat. The effects of your existence can still be detected, such as water moving or footsteps in snow, or the direction a monster is attacked.",
    },
    {
        name:"Theoretical Armor",
        rarity: "unique",
        bonus: "This armor's base armor bonus becomes a deflection modifier instead (not including enchantments). When this enchantment is active your armor's max dexterity bonus increases by 4, and armor check penalty decreases by 3.",
    },
    {
        name:"Endure Elements",
        rarity: "unique",
        bonus: "Gain resistance 20 to fire, acid, cold, and electricity. You can spend spell points in increments of 4 as an immediate action (before damage is rolled) to increase your elemental resistance of a single type (fire, acid, cold, or electricity) by 5 for a single effet. Every time your elemental resistance stops you from taking damage you heal hit points equal to half its original damage. This can only activate once per effect.",
    },        
    {
        name:"Shadow Stepping",
        rarity: "unique",
        bonus: "Whenever a creature misses you with an attack you can move 5 feet and until your next turn gain +1 dodge bonus to AC. This 5-foot movement does not provoke from the creature that missed you, but otherwise provokes.",
    },
    {
        name:"Berserker Armor",
        rarity: "unique",
        bonus: "You can take 1 point of constitution drain to gain a morale bonus to your melee damage rolls equal to the armors enhancement bonus and gain an equal amount of DR/- for 1 round (these effects stack, and you can spend multiple points of constitution at a time), and during the round you cannot die from hit point damage (though your health may still be reduced). At the start of your next turn you must make a will saving throw dc=(10 * rounds active + damage bonus given by this effect) or you are forced to activate this ability again, spending twice as much constitution as you did on the previous round, and you must spend your full turn attacking (or moving to and attacking) the nearest creature to you and can take no other actions. You are immune to all other mental effects while this is active. A friendly adjacent creature can make a diplomacy check as a standard action vs the DC to end the effect. You are exhausted for rounds equal to how many rounds this ability was active once it ends.",
    },
    {
        name:"Battlemind",
        rarity: "unique",
        bonus: "You can spend spell points in increments of 3 as an immediate action to gain a +1 bonus to a saving throw, up to a maximum of twice your armors enhancement bonus.",
    },
    {
        name:"Ninja's Cyber Garb",
        rarity: "unique",
        bonus: "While at least 30 feet away from any ally you gain fast healing equal to your constitution score-10. If you are healed by any effect from an ally (but not yourself) this ability stops for 4 rounds. While below half health double your movement speed as long as you are not moving towards an ally.",
    },
    {
        name:"Plot Armor",
        rarity: "unique",
        bonus: "You can reroll a saving throw or force a creatures attack against you to be rerolled with a penalty equal to you armors enhancement bonus, you can activate this after the roll is determined a failure or success. Each time you do this lower your armor class by 2 and your saves by 1 for the rest of the floor. You can only do this times up to your armor's enchantement bonus.",
    },  
    {
        name:"Red Cape",
        rarity: "unique",
        bonus: "For rounds equal to your armors enhancement bonus per floor you can cause an enemy to only be able to attack or use other offensive abilities against you. Activating this ability is a swift action and requires you to see the target. If the target is unable to attack you for any reason on its next turn other than distance it automatically overcomes it (including physical obstacles, magic, or its own movement speed), and gains +5 to its attack and damage rolls against you. It can still use AOE effects but it must directly target you with them. This is a mind-effecting effect.",
    },
    {
        name:"Genius Defenses",
        rarity: "unique",
        bonus: "You can add your highest mental stat/2 as a dodge bonus to your armor class, to a maximum of your armors enhancement bonus.",
    },
    {
        name:"Enhancement Enhancement",
        rarity: "unique",
        bonus: "Increase numerical bonuses of all of your other armor enchantments by +1. Choose one enchantment, it is increased by 1.5x instead (rounded down). The chosen enchantement can be changed as a swift action.",
    },
    {
        name:"Augmentation Plate",
        rarity: "unique",
        bonus: "Gain your armors enchantment bonus/2 to your ability scores of your choice. You must choose how to split this bonus at the start of each floor, or when you get this enchantment, or when you gain a new enhancement bonus.",
    },
    {
        name:"Heal Sponge",
        rarity: "unique",
        bonus: "All healing abilities used on you by an ally are increased by 25%, however you can no longer heal yourself (including potions). If you would benefit from a healing ability from yourself you instead gain your armors enhancement bonus as a bonus to attack and damage for your next attack.",
    },
]